import { Component, input } from '@angular/core';
import { AttributesStep } from '../../../../add-product-component/steps/attributes-step/attributes-step';

@Component({
  selector: 'app-edit-attributes',
  imports: [AttributesStep],
  templateUrl: './edit-attributes.html',
  styleUrl: './edit-attributes.scss',
})
export class EditAttributes {
  productId = input.required();
}
